import { BriefcaseFill } from "react-bootstrap-icons";
import { handleFollow } from "../api/timelineAPIs";
import Avatar from "../components/reusable/Avatar";

const SuggestedFollows = ({
  user,
  businessName,
  category,
  secondParty,
  secondPartyEmail,
}) => {
  return (
    <div className="suggestion-card">
      <div className="suggestion-info">
        <Avatar size="sm" />
        <div className="suggestion-details">
          <span className="suggestion-name">
            {businessName ?? "My Business Limited"}
          </span>
          <span className="suggestion-category">
            <BriefcaseFill style={{ fontSize: "10px", marginRight: "4px" }} />
            {category ?? "Financial"}
          </span>
        </div>
      </div>
      <button
        className="follow-btn"
        onClick={() => handleFollow(user, secondParty, secondPartyEmail)}
      >
        Follow
      </button>
    </div>
  );
};

export default SuggestedFollows;
